import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SupportedLanguages } from '@constants/constants.type';
import { Locale } from 'date-fns';
import { ca, de, enGB, es, fr, it, pt } from 'date-fns/locale';

export const getFnsLocale = (locale: SupportedLanguages) => {
  switch (locale) {
    case 'en':
      return enGB;
    case 'es':
      return es;
    case 'ca':
      return ca;
    case 'it':
      return it;
    case 'fr':
      return fr;
    case 'de':
      return de;
    case 'pt':
      return pt;
    default:
      return enGB;
  }
};

export const useGetFnsLocale = () => {
  const { i18n } = useTranslation();
  const [dateFnsLocale, setDateFnsLocale] = useState<Locale>(enGB);
  const locale = i18n.language as SupportedLanguages;

  useEffect(() => {
    function importLocale() {
      const localePromise: Locale = getFnsLocale(locale);
      setDateFnsLocale(localePromise as Locale);
    }
    importLocale();
  }, [locale]);

  return {
    dateFnsLocale,
    i18n,
  };
};
